<div class="import-products" *ngIf="!control?.errors?.['importInputFile'] && !!control?.value">
  <cx-accordion [title]="'Itens Encontrados - 2 itens'">
    <div class="cart-product-item">
      <div class="cart-product-item-datas">
        <img
          src="https://www.drogasil.com.br/_next/image?url=https%3A%2F%2Fproduct-data.raiadrogasil.io%2Fimages%2F3538082.webp&w=828&q=75"
          alt=""
        />

        <div class="cart-product-item-datas-wrapper">
          <span class="cart-product-item-datas-title">Antigripal Naldecon Multi 400mg + 400mg + 20mg 16 Comprimidos </span>
          <span class="cart-product-item-datas-ean">
            <strong>{{ 'cart.ean' | translate }}:</strong>
            <span>1234567890123</span>
          </span>
        </div>
      </div>

      <div class="cart-product-item-input">
        <cx-input-quantity [label]="'Qtde'" />
      </div>
    </div>

    <div class="cart-product-item">
      <div class="cart-product-item-datas">
        <img
          src="https://www.drogasil.com.br/_next/image?url=https%3A%2F%2Fproduct-data.raiadrogasil.io%2Fimages%2F3538082.webp&w=828&q=75"
          alt=""
        />

        <div class="cart-product-item-datas-wrapper">
          <span class="cart-product-item-datas-title">Antigripal Naldecon Multi 400mg + 400mg + 20mg 16 Comprimidos </span>
          <span class="cart-product-item-datas-ean">
            <strong>{{ 'cart.ean' | translate }}:</strong>
            <span>1234567890123</span>
          </span>
        </div>
      </div>

      <div class="cart-product-item-input">
        <cx-input-quantity [label]="'Qtde'" />
      </div>
    </div>
  </cx-accordion>

  <cx-accordion [title]="'Itens Não Encontrados - 3 itens'">
    <div class="products-not-found">
      <div class="products-not-found-ean">
        <strong>{{ 'cart.ean' | translate }}:</strong>
        <span>1234567890123</span>
      </div>

      <div class="products-not-found-justification">
        <span>{{ 'cart.import.descontinued.title' | translate }}</span>
      </div>

      <div class="products-not-found-enable-export">
        <span>{{ 'cart.import.descontinued.enableExport' | translate }}:</span>
        <cx-switcher />
      </div>
    </div>

    <div class="products-not-found">
      <div class="products-not-found-ean">
        <strong>{{ 'cart.ean' | translate }}:</strong>
        <span>1234567890123</span>
      </div>

      <div class="products-not-found-justification">
        <span>{{ 'cart.import.descontinued.title' | translate }}</span>
      </div>

      <div class="products-not-found-enable-export">
        <span>{{ 'cart.import.descontinued.enableExport' | translate }}:</span>
        <cx-switcher />
      </div>
    </div>

    <div class="products-not-found">
      <div class="products-not-found-ean">
        <strong>{{ 'cart.ean' | translate }}:</strong>
        <span>1234567890123</span>
      </div>

      <div class="products-not-found-justification">
        <span>{{ 'cart.import.descontinued.title' | translate }}</span>
      </div>

      <div class="products-not-found-enable-export">
        <span>{{ 'cart.import.descontinued.enableExport' | translate }}:</span>
        <cx-switcher />
      </div>
    </div>
  </cx-accordion>

  <cx-button class="btn-outline" [iconPosition]="'left'" [icon]="'download'">{{ 'cart.import.descontinued.export' | translate }}</cx-button>
</div>
